<div class="button-wrapper">
  <div class="button" (click)="togglePanel()">
    <div class="button-text">
      <img alt="Filter" src="assets/core/table-button/filter.svg" />
    </div>
    <div class="filter-type">
      <span>{{ "FILTER" | translate }}
        <span class="green-text">{{ activeFilterCount }} {{ "APPLIED" | translate }}</span>
      </span>
    </div>
  </div>
</div>

@if (isOpen) {
<div class="overlay" (click)="onCancel()"></div>
<div class="container flex-column d-flex m-0 p-0">
  <div class="row g-0 m-0 p-4 d-flex justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "ADVANCEFILTER" | translate }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="onCancel()">
      <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
    </div>
  </div>

  <div class="row g-0 m-0 body">
    <ng-content></ng-content>
  </div>

  <div class="row g-0 m-0 p-3 align-items-end justify-content-between bordert mt-auto">
    <div class="col-md-6 pt-2 pb-2 ps-2 d-flex justify-content-start">
      <span class="item-name">{{ numberOfResults }} {{ "RESULTS" | translate }}</span>
    </div>
    <div class="col-md-6 d-flex justify-content-center rounded button-view-results p-2" (click)="onApply()">
      <span>{{ "VIEWRESULTS" | translate }}</span>
    </div>
  </div>
</div>
}
